
import stripHTML from "@/helpers/stripHTML";
import { CategoryContent } from "@/typings/categoryContent";

let data: CategoryContent[] = [];

retailCategoriesDetails?.categorytiles.forEach((tile) => {
  if(tile.category && tile.Icon && tile.expandedDescription &&  tile.src) {
    const card =  {
      expanded: true,
      category: tile.category,
      Icon: tile.Icon,
      description:"",
      title: tile.title,
      expandedDescription: tile.expandedDescription,
      image: tile.src,
      imagePriority: "low",
      id: tile.id,
      searchTerm: stripHTML(tile.title),
      dataReason: stripHTML(tile.title),
    }
    data.push(card);

  }
})
const cardContent = data as CategoryContent[];
export default cardContent;
